import React from "react";
import { Navigate } from "react-router-dom";
import { useOktaAuth } from '@okta/okta-react';
import { getUser } from "../hooks/user.actions";
import { setAccessToken, getAccessToken } from "../helpers/tokenStore";

function OktaProtectedRoute({ children }) {
  const { authState } = useOktaAuth();

  const isAuthPending = authState === null;
  const isAuthenticated = authState?.isAuthenticated || getUser() !== null;
  const rawToken = authState?.accessToken?.accessToken;

  // Synchronously seed the token store during render so that class-component
  // componentDidMount calls (which fire before any useEffect, including
  // AuthTokenSync's) already find a token in the store.
  if (rawToken && !getAccessToken()) {
    setAccessToken(rawToken);
  }

  const isTokenReady = rawToken != null || getUser() !== null;

  if (isAuthPending || (isAuthenticated && !isTokenReady)) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login/" replace />;
  }

  return <>{children}</>;
}

export default OktaProtectedRoute;
